import { 
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  Edit,
  required,
  email,
} from 'react-admin';
import { Box, Divider, Typography } from '@mui/material';

export { UserList } from './UserList';
export { UserShow } from './UserShowEnhanced';

export const UserCreate = () => (
  <Create>
    <SimpleForm defaultValues={{ emailVerified: true }}>
      <TextInput source="firstName" validate={[required()]} label="First Name" />
      <TextInput source="lastName" validate={[required()]} label="Last Name" />
      <TextInput source="email" validate={[required(), email()]} />
      <TextInput source="password" type="password" validate={[required()]} />
    </SimpleForm>
  </Create>
);

export const UserEdit = () => (
  <Edit>
    <SimpleForm>
      <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 2, mt: 1 }}>
        Basic Information
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <TextInput source="firstName" validate={[required()]} label="First Name" sx={{ flex: 1, minWidth: 200 }} />
        <TextInput source="lastName" validate={[required()]} label="Last Name" sx={{ flex: 1, minWidth: 200 }} />
      </Box>
      <TextInput source="email" validate={[required(), email()]} fullWidth />

      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 2 }}>
        Contact Information
      </Typography>
      <TextInput source="phoneNumber" label="Phone Number" fullWidth />
      <TextInput source="phoneExtension" label="Phone Extension" fullWidth />

      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" gutterBottom color="primary" sx={{ mb: 2 }}>
        Address
      </Typography>
      <TextInput source="addressLine1" label="Address Line 1" fullWidth />
      <TextInput source="addressLine2" label="Address Line 2" fullWidth />
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <TextInput source="city" label="City" sx={{ flex: 1, minWidth: 200 }} />
        <TextInput source="province" label="Province/State" sx={{ flex: 1, minWidth: 200 }} />
        <TextInput source="postalCode" label="Postal/ZIP Code" sx={{ flex: 1, minWidth: 200 }} />
      </Box>
    </SimpleForm>
  </Edit>
);